import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { SAMPLE_TEMPLATES } from "../lib/sample-data";
import { Plus } from "lucide-react";
import { cn } from "../lib/utils";

const CATS = ["all", "slides", "workbook", "book", "cover", "flyer", "campaign"];

export default function Templates() {
  const [cat, setCat] = useState("all");
  const filtered = cat === "all" ? SAMPLE_TEMPLATES : SAMPLE_TEMPLATES.filter((t) => t.category === cat);

  return (
    <div data-testid="templates-page" className="space-y-8">
      <PageHeader
        kicker="TemplateLab"
        title="Templates"
        description="Premium-built templates for books, workbooks, slides, flyers, covers, and campaigns."
        actions={
          <button
            data-testid="template-new-btn"
            className="inline-flex items-center gap-2 px-4 h-11 rounded-xl pl-btn-aqua text-sm"
          >
            <Plus className="h-4 w-4" /> Create Template
          </button>
        }
      />

      <div className="flex gap-2 flex-wrap">
        {CATS.map((c) => (
          <button
            key={c}
            data-testid={`tcat-${c}`}
            onClick={() => setCat(c)}
            className={cn(
              "px-3 h-9 rounded-full text-xs capitalize border transition",
              cat === c
                ? "bg-[var(--pl-aqua)]/15 text-[var(--pl-aqua)] border-[var(--pl-aqua)]/40"
                : "border-[var(--pl-border)] text-[var(--pl-text-muted)] hover:text-[var(--pl-text)]"
            )}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filtered.map((t, i) => (
          <div
            key={t.id}
            data-testid={`template-${t.id}`}
            className="pl-fade-up rounded-2xl overflow-hidden border border-[var(--pl-border)] bg-[var(--pl-surface)]/70 pl-lift cursor-pointer"
            style={{ animationDelay: `${i * 40}ms` }}
          >
            <div className="aspect-[3/4] bg-[var(--pl-bg-2)] overflow-hidden relative">
              <img src={t.thumb} alt={t.name} className="w-full h-full object-cover" />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[10px] uppercase tracking-[0.18em] bg-black/50 backdrop-blur text-white border border-white/10">
                {t.category}
              </div>
            </div>
            <div className="p-3">
              <div className="text-sm font-medium text-[var(--pl-text)] truncate">{t.name}</div>
              <div className="text-[11px] text-[var(--pl-text-muted)]">PremierLab Verified</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
